import { render } from "./WorldListItem.vue?vue&type=template&id=fefbdb1c&scoped=true&bindings={}"
import script from "./WorldListItem.vue?vue&type=script&lang=ts"
export * from "./WorldListItem.vue?vue&type=script&lang=ts"

import "./WorldListItem.vue?vue&type=style&index=0&id=fefbdb1c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fefbdb1c"

export default script